import BlogWrapper from "../../components/blog"

const BlogPage = () =>{
    return(
        <>
     <BlogWrapper/>
     </>
    )
}

export default BlogPage